import { DateObject } from 'react-multi-date-picker'

type DateRange = [Date, Date]
export const areDateRangesEqual = (range1: DateRange, range2: DateRange) =>
  (range1[0] &&
    range1[1] &&
    new DateObject(range1[0]).toString() === new DateObject(range2[0]).toString() &&
    new DateObject(range1[1]).toString() === new DateObject(range2[1]).toString()) ||
  (new DateObject(range1[1]).toString() === new DateObject(range2[0]).toString() &&
    new DateObject(range1[0]).toString() === new DateObject(range2[1]).toString())
